// import React from "react";
// import "../src/style/T&M.css";

// const TermsAndConditions = () => {
//     return (
//         <>
//             <nav
//                 className="breadcrumb"
//                 style={{
//                     backgroundImage: "url('./airplane.avif')",
//                     backgroundSize: "cover",
//                     backgroundPosition: "center",
//                     padding: "55px",
//                     color: "white"
//                 }}
//             >
//                 <a href="/">Home</a> &gt; <span>Terms & Conditions</span>
//             </nav>

//             <div className="terms-container container">
//                 <h1 className="terms-title">Terms & Conditions</h1>
//                 <p className="terms-text">
//                     By booking a flight through our website, you agree to comply with the following terms and conditions.
//                     Please read them carefully before proceeding.
//                 </p>

//                 <h2 className="terms-heading">1. Booking and Payments</h2>
//                 <p className="terms-text">
//                     - All flight bookings must be made through our official platform.<br />
//                     - Full payment must be completed at the time of booking to confirm your ticket.<br />
//                     - Prices are subject to change based on availability and airline policies.
//                 </p>

//                 <h2 className="terms-heading">2. Cancellation and Refunds</h2>
//                 <p className="terms-text">
//                     - Cancellations made within 24 hours of booking may be eligible for a full refund.<br />
//                     - Refund policies vary based on the airline's cancellation terms.<br />
//                     - Non-refundable tickets are not eligible for any reimbursement.
//                 </p>

//                 <h2 className="terms-heading">3. Check-in and Boarding</h2>
//                 <p className="terms-text">
//                     - Passengers must check in at least 2 hours before domestic flights and 3 hours before international flights.<br />
//                     - Failure to arrive at the boarding gate on time may result in ticket cancellation without a refund.<br />
//                     - Government-issued ID and necessary travel documents must be presented at check-in.
//                 </p>

//                 <h2 className="terms-heading">4. Baggage Allowance</h2>
//                 <p className="terms-text">
//                     - Each passenger is allowed a specific baggage limit as per airline rules.<br />
//                     - Excess baggage may be subject to additional charges.<br />
//                     - Restricted items must not be carried in checked or cabin baggage.
//                 </p>

//                 <h2 className="terms-heading">5. Travel Restrictions</h2>
//                 <p className="terms-text">
//                     - Passengers must comply with all travel regulations, including visa and vaccination requirements.<br />
//                     - The airline is not responsible for denied boarding due to missing documentation.<br />
//                     - COVID-19 travel restrictions may apply depending on the destination.
//                 </p>

//                 <h2 className="terms-heading">6. Flight Changes and Delays</h2>
//                 <p className="terms-text">
//                     - Airlines reserve the right to modify flight schedules due to operational reasons.<br />
//                     - In case of flight delays, passengers will be notified via email or SMS.<br />
//                     - Compensation for delays or cancellations depends on airline policies.
//                 </p>

//                 <h2 className="terms-heading">7. Liability and Responsibilities</h2>
//                 <p className="terms-text">
//                     - The airline is responsible for passenger safety during travel.<br />
//                     - We are not liable for lost or stolen belongings at the airport or during transit.<br />
//                     - Any disputes must be resolved as per airline policies and applicable laws.
//                 </p>

//                 <h2 className="terms-heading">8. Contact Us</h2>
//                 <p className="terms-text">
//                     If you have any questions regarding our terms, please contact us at support@example.com.
//                 </p>
//             </div>
//         </>
//     );
// };

// export default TermsAndConditions;


import React from "react";
import "../src/style/T&M.css";

const TermsAndConditions = () => {
    return (
        <>
            <nav
                className="breadcrumb"
                style={{
                    backgroundImage: "url('./airplane.avif')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    padding: "55px",
                    color: "white",
                    textAlign: "left"
                }}
            >
                <a href="/" style={{ color: "white", textDecoration: "none", fontWeight: "bold" }}>Home</a> &gt; <span>Terms & Conditions</span>
            </nav>

            <div className="terms-container container" style={{ padding: "40px 20px", textAlign: "left" }}>
                <h1 className="terms-title" style={{ fontSize: "32px", fontWeight: "bold", paddingBottom: "20px" }}>Terms & Conditions</h1>
                <p className="terms-text" style={{ lineHeight: "1.8", fontSize: "18px" }}>
                    By booking a flight through our website, you agree to comply with the following terms and conditions.
                    Please read them carefully before proceeding.
                </p>

                <h2 className="terms-heading">1. Booking and Payments</h2>
                <p className="terms-text">
                    - All flight bookings must be made through our official platform.<br />
                    - Full payment must be completed at the time of booking to confirm your ticket.<br />
                    - Prices are subject to change based on availability and airline policies.
                </p>

                <h2 className="terms-heading">2. Cancellation and Refunds</h2>
                <p className="terms-text">
                    - Cancellations made within 24 hours of booking may be eligible for a full refund.<br />
                    - Refund policies vary based on the airline's cancellation terms.<br />
                    - Non-refundable tickets are not eligible for any reimbursement.
                </p>

                <h2 className="terms-heading">3. Check-in and Boarding</h2>
                <p className="terms-text">
                    - Passengers must check in at least 2 hours before domestic flights and 3 hours before international flights.<br />
                    - Failure to arrive at the boarding gate on time may result in ticket cancellation without a refund.<br />
                    - Government-issued ID and necessary travel documents must be presented at check-in.
                </p>

                <h2 className="terms-heading">4. Baggage Allowance</h2>
                <p className="terms-text">
                    - Each passenger is allowed a specific baggage limit as per airline rules.<br />
                    - Excess baggage may be subject to additional charges.<br />
                    - Restricted items must not be carried in checked or cabin baggage.
                </p>

                <h2 className="terms-heading">5. Travel Restrictions</h2>
                <p className="terms-text">
                    - Passengers must comply with all travel regulations, including visa and vaccination requirements.<br />
                    - The airline is not responsible for denied boarding due to missing documentation.<br />
                    - COVID-19 travel restrictions may apply depending on the destination.
                </p>

                <h2 className="terms-heading">6. Flight Changes and Delays</h2>
                <p className="terms-text">
                    - Airlines reserve the right to modify flight schedules due to operational reasons.<br />
                    - In case of flight delays, passengers will be notified via email or SMS.<br />
                    - Compensation for delays or cancellations depends on airline policies.
                </p>

                <h2 className="terms-heading">7. Liability and Responsibilities</h2>
                <p className="terms-text">
                    - The airline is responsible for passenger safety during travel.<br />
                    - We are not liable for lost or stolen belongings at the airport or during transit.<br />
                    - Any disputes must be resolved as per airline policies and applicable laws.
                </p>

                <h2 className="terms-heading">8. Contact Us</h2>
                <p className="terms-text">
                    If you have any questions regarding our terms, please contact us at support@example.com.
                </p>
            </div>
        </>
    );
};

export default TermsAndConditions;
